import { AppState } from '../../../store/App.reducer'
import { Domaine } from '../interfaces/domaine.interface'

export const selectDomaine = (state: AppState): Domaine[] => state.domaine.domaines
